export const OrganizationPermission = {
    API_KEYS_VIEW_ALL: "api_keys.view_all",
    BATCH_FILES_VIEW_ALL: "batch_files.view_all",
    ORG_MANAGE_ROLES: "org.manage_roles",
    ORG_MANAGE_PERMISSIONS: "org.manage_permissions",
    ORG_INVITE_MEMBERS: "org.invite_members",
    ORG_REMOVE_MEMBERS: "org.remove_members",
    BILLING_VIEW_CREDITS: "billing.view_credits",
    BILLING_MANAGE_BILLING: "billing.manage_billing",
    BILLING_VIEW_RECEIPTS: "billing.view_receipts",
    DASHBOARD_VIEW_ORG_SPEND: "dashboard.view_org_spend",
} as const;

export type OrganizationPermissionValue =
    typeof OrganizationPermission[keyof typeof OrganizationPermission];

export const ORGANIZATION_ROLES = ["owner", "admin", "member"] as const;
export type OrganizationRoleValue = typeof ORGANIZATION_ROLES[number];

export const ROLE_LABELS: Record<OrganizationRoleValue, string> = {
    owner: "Proprietário",
    admin: "Admin",
    member: "Membro",
};

const ALL_PERMISSION_VALUES = Object.values(OrganizationPermission);

export const DEFAULT_ROLE_PERMISSIONS: Record<OrganizationRoleValue, OrganizationPermissionValue[]> = {
    owner: ALL_PERMISSION_VALUES,
    admin: [
        OrganizationPermission.API_KEYS_VIEW_ALL,
        OrganizationPermission.ORG_MANAGE_ROLES,
        OrganizationPermission.ORG_MANAGE_PERMISSIONS,
        OrganizationPermission.ORG_INVITE_MEMBERS,
        OrganizationPermission.ORG_REMOVE_MEMBERS,
        OrganizationPermission.BILLING_VIEW_CREDITS,
        OrganizationPermission.BILLING_MANAGE_BILLING,
        OrganizationPermission.BILLING_VIEW_RECEIPTS,
        OrganizationPermission.DASHBOARD_VIEW_ORG_SPEND,
    ],
    member: [
        OrganizationPermission.BILLING_VIEW_RECEIPTS,
    ],
};

export const hasPermission = (
    permissions: string[] | undefined,
    permission: OrganizationPermissionValue,
): boolean => Boolean(permissions?.includes(permission));

export const listAllPermissions = (): OrganizationPermissionValue[] => ALL_PERMISSION_VALUES;
